// extracted by mini-css-extract-plugin
export var active = "_cz-c";
export var compactArrow = "_cz-5";
export var container = "_cz-0";
export var dot = "_cz-b";
export var dotContainer = "_cz-a";
export var hoverArrowButton = "_cz-7";
export var hoverArrowContainer = "_cz-6";
export var leftHoverArrowContainer = "_cz-8 _cz-6";
export var rightHoverArrowContainer = "_cz-9 _cz-6";
export var slide = "_cz-4";
export var sliderContainer = "_cz-1";
export var sliderContainerVisibleOverflow = "_cz-2";
export var sliderOverflow = "_cz-3";
export var vignetteBoth = "_cz-f";
export var vignetteLeft = "_cz-e";
export var vignetteRight = "_cz-d";